import React from "react";

export default (props) => {
  return (
    <div>
      {props.has_randomization_platform_step_3_patient ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.randomization_platform_step_3_patient_content,
          }}
        />
      ) : (
        <div style={{ textAlign: "justify" }}>
          <h4 align="center">
            Informed Consent Form for Participation in a Research Study
            <br/>
            (Subject Deferred Consent Form)
          </h4>
          <h3>Study Title:</h3>
          <p>
            Alteplase Compared to Tenecteplase in patients with Acute Ischemic
            Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized
            Controlled Trial
          </p>

          <h3>Study Doctor: </h3>
          <p>
            Dr. Aleksandra Pikula
            <br />
            Department of Neurology
            <br />
            University Health Network
            <br />
            Toronto Western Hospital
            <br />
            416-464-0929
          </p>

          <p>
            <b>Sponsor/Funder(s):</b> University of Calgary
          </p>
          <p>
            <b>Emergency Contact Number:</b> (24 hours / 7 days a week):
            416-464-0929
          </p>

          <p>
            <u>INTRODUCTION</u>
          </p>
          <p>
            As a Substitute Decision Maker, you are being asked to provide
            informed consent on behalf of a person who is unable to provide
            consent for him/herself. If the participant gains the capacity to
            consent for him/herself, your consent for them will end. Throughout
            this form, “you” means the person you are representing.
          </p>
          <p>
            You are being invited to participate in a clinical trial (a type of
            study that involves research). You are invited to participate in
            this trial because you have had an acute ischemic stroke. This
            happens when a clot blocks a blood vessel, reducing the blood supply
            to a part of your brain. When this happens, the affected part of the
            brain can be damaged, sometimes permanently. This consent form
            provides you with information to help you make an informed choice.
            Please read this document carefully and ask any questions you may
            have. All your questions should be answered to your satisfaction
            before you decide whether to participate in this research study.
          </p>
          <p>
            Because a stroke is an emergency situation where every minute
            counts, and you may have been incapacitated at the time of your
            stroke, you were enrolled by deferral of consent, meaning that you
            received either Alteplase or Tenecteplase, “clot-busting”
            medications used to treat your stroke without first being asked.
            This process was designed in consultation with experts in research
            ethics and with stroke patients, and was approved by your hospital’s
            research ethics board.
          </p>
          <p>
            The administration of either Alteplase or Tenecteplase cannot be
            undone. We are asking for your consent to stay in the study for
            ongoing data collection.
          </p>
          <p>
            Taking part in this study is voluntary. You have the option to not
            participate at all or you may choose to leave the study at any time.
            Whatever you choose, it will not affect the usual medical care that
            you receive outside the study.
          </p>
          <p>
            Please take your time in making your decision. You may find it
            helpful to discuss it with your friends and family.
          </p>
          <br />

          <p>
            <u>IS THERE A CONFLICT OF INTEREST?</u>
          </p>
          <p>
            This study is funded by the University of Calgary with a grant from
            the Canadian Institute of Health Research. Study medications are
            provided by the hospital pharmacy at no cost to you. The Toronto
            Western Hospital is receiving financial payment to cover the cost of
            conducting this study.
          </p>
          <br />

          <p>
            <u>WHAT IS THE BACKGROUND INFORMATION FOR THIS STUDY?</u>
          </p>
          <p>
            The standard or usual treatment for stroke emergencies caused by a
            blood clot is a medication called Alteplase (Tissue Plasminogen
            Activator - tPA). We know that Alteplase can reduce brain damage
            from a stroke by dissolving the clot in the blocked artery. This
            helps to restore normal blood supply to the brain before it becomes
            permanently damaged. Alteplase is the usual treatment for stroke
            patients. Despite the benefits of Alteplase at reducing brain damage
            and disability in stroke patients, there are risks including brain
            bleeding.
          </p>
          <p>
            Tenecteplase (TNK) is another clot-dissolving medication that is
            similar to Alteplase, and is often used for patients who have a
            heart attack, where there is a clot blocking a blood vessel in the
            heart. It is also a tissue plasminogen activator. Health Canada, the
            regulatory body that oversees the use of drugs in Canada, has not
            approved the sale or use of Tenecteplase for acute ischemic stroke.
            Health Canada has allowed Tenecteplase to be used in this study.
            Although Tenecteplase is not currently approved for use in acute
            stroke care, it has shown promising results in recent stroke
            studies.
          </p>
          <br />

          <p>
            <u>WHY IS THIS STUDY BEING DONE?</u>
          </p>
          <p>
            The main purpose of this study is to compare Alteplase with
            Tenecteplase for stroke treatment to determine if patients who
            receive Tenecteplase do as well as those who receive Alteplase, when
            followed out to 3 months after their stroke.
          </p>
          <br />

          <p>
            <u>WHAT OTHER CHOICES ARE THERE?</u>
          </p>
          <p>
            You do not have to take part in this study in order to receive
            treatment or care. You can opt out of study follow-up or health
            record linkage. Standard of care treatments for your stroke will not
            be affected, including, but not limited to treatment with:
            <ul>
              <li>
                Blood thinners called antiplatelets which prevent blood cells
                called platelets from clumping
              </li>
              <li>
                Endovascular thrombectomy (EVT), a surgery to try to remove the
                blood clot from your brain
              </li>
            </ul>
          </p>

          <p>Other research studies may be available.</p>

          <p>
            <u>HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?</u>
          </p>
          <p>
            It is anticipated that about 1600 people will take part in this
            study, from research sites located in Canada.
          </p>
          <p>
            This study should take 3 years to complete and the results should be
            known in about 3.5 years.
          </p>
          <br />

          <p>
            <u>WHAT WILL HAPPEN DURING THIS STUDY?</u>
          </p>

          <p>
            <u>ASSIGNMENT TO A GROUP</u>
          </p>
          <p>
            You have been "randomized" into one of the groups described below.
            Randomization means that you were put into a group by chance (like
            flipping a coin). There is no way to predict which group you would
            be assigned to before randomization. You had a 50% chance of being
            placed in either group. Neither you, the study staff, nor the study
            doctors can choose what group you would be in.
          </p>
          <p>You will be told which group you are in.</p>
          <p>
            Once 1600 participants have entered the study from all of the
            research sites combined, no more participants will be enrolled into
            the study at any site.
          </p>
          <br />

          <p>
            <u>WHAT IS THE STUDY INTERVENTION?</u>
          </p>
          <p>
            Experimental Intervention: At the time of your stroke, you were
            given a clot-busting medication by needle into one of your veins.
            You received this medication once.
          </p>
          <p>
            Group 1 <u>(Experimental intervention):</u> Tenecteplase (TNK)
          </p>
          <p>
            If you were randomized to this group, we have given you a
            clot-busting drug called Tenecteplase by needle into one of your
            veins. This procedure took about 1 minute. This medication was only
            given to you one time.
          </p>
          <p>
            Group 2 <u>(Non-Experimental/Standard Intervention):</u> Alteplase
            (tPA)
          </p>
          <p>
            If you were randomized to this group, we have given you a
            clot-busting drug called Alteplase by needle into one of you veins.
            This procedure took about 1 hour. This medication was only given to
            you one time.
          </p>
          <p>
            The administration of either Alteplase or Tenecteplase cannot be
            undone.
          </p>
          <br />

          <p>
            <u>WHAT ARE THE RESPONSIBILITIES OF STUDY PARTICIPANTS?</u>
          </p>
          <p>
            If you choose to participate in this study, you will be expected to:
            <ul>
              <li>
                Complete a telephone interview 90-120 days after your stroke
              </li>
              <ul>
                <li>
                  An important part of this study is to see how patients have
                  recovered and are functioning at 3 months after their stroke.
                  This assessment will be done through a telephone interview
                  with research staff from the University of Calgary. The
                  interview will last about 5 minutes. You will be called one
                  time at 3 months (as close to 90 days as possible, to a
                  maximum of 120 days depending on your schedule). For
                  participants who are not fluent in English, the services of an
                  interpreter will be offered so as not to exclude anyone on the
                  basis of language.
                </li>
              </ul>
              <li>
                Complete memory and attention tests online
                <ul>
                  <li>
                    <p>
                      If you are able and interested, we will ask you to
                      complete an online assessment at 3-months and 1 year after
                      the stroke, to find out if there are any differences in
                      memory or thinking between the groups of people who
                      received the two drugs. You do not have to complete this
                      online assessment to be part of the main study
                    </p>
                    <p>
                      If you consent, you will be provided with a link and
                      instructions to complete memory and attention tests
                      online. The purpose of these tests is to understand how
                      the study intervention and illness affects your brain
                      function. Each test will take about 35-45 minutes to
                      complete and you can do this from your home. You can
                      choose not to complete the memory and attention tests if
                      you wish.
                    </p>
                    <p>
                      Even though you may have completed the memory and
                      attention tests, these results will not be reviewed by
                      your health care team or study team.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </p>
          <br />

          <p><b>
            If you consent to participate in this study, regular standard of
            care assessments will be performed, including routine follow up as
            planned by your treating physician.</b>
          </p>
          <br />

          <p>
            <u>HOW LONG WILL PARTICIPANTS BE IN THE STUDY?</u>
          </p>
          <p>The study participation can last for up to 1 year.</p>
          <p>
            No matter which group you are randomized to, we would like to keep
            track of your health for 3 months to look at the long-term effects
            of your participation on this study. After the 3-month assessment
            (phone call and online assessment) is finished, your participation
            in the study’s main phase will be complete, and you can chose to
            continue with the online testing at 3 months and at 1 year, if you
            wish.
          </p>
          <br />

          <p>
            <u>CAN PARTICIPANTS CHOOSE TO LEAVE THE STUDY?</u>
          </p>
          <p>
            You can choose to end your participation in this research (called
            withdrawal) at any time without having to provide a reason. If you
            choose to withdraw from the study, you are encouraged to contact the
            study doctor or study staff.
          </p>
          <p>
            You may withdraw your permission to use information that was
            collected about you for this study at any time by letting the study
            doctor know.
          </p>
          <p>
            Information that was recorded before you withdrew will be used by
            the researchers for the purposes of the study, but no information
            will be collected or sent to the sponsor after you withdraw your
            permission.
          </p>
          <p>
            You can also choose to withdraw from the study but allow your data
            to be collected from that point onward via health record linkage. If
            you choose this option, we will not contact you about the study in
            the future.
          </p>
          <br />

          <p>
            <u>CAN PARTICIPATION IN THIS STUDY END EARLY?</u>
          </p>
          <p>
            The study doctor may stop your participation in the study early, and
            without your consent, for reasons such as:
            <ul>
              <li>The Sponsor decides to stop the study</li>
              <li>
                The Regulatory Authority/ies (for example, Health Canada) or
                research ethics board withdraw permission for this study to
                continue
              </li>
            </ul>
          </p>
          <p>
            If you are removed from this study, the study doctor will discuss
            the reasons with you and plans will be made for your continued care
            outside of the study
          </p>
          <br />

          <p>
            <u>WHAT ARE THE RISKS OR HARMS OF PARTICIPATING IN THIS STUDY?</u>
          </p>
          <p>
            You may experience side effects from participating in this study.
            Some side effects are known and are listed below, but there may be
            other side effects that are not expected. You should discuss these
            with the study doctor.
          </p>
          <p>
            The study doctor will watch you closely to see if you have side
            effects. When possible, other medicine will be given to you to make
            side effects less serious and more tolerable. Many side effects go
            away shortly after the study intervention is stopped, but in some
            cases side effects can be serious, long-lasting, permanent, or may
            even cause death.
          </p>
          <p>
            All medical procedures involve some risk of injury. There may be
            risks associated with this study that are unknown and cannot be
            predicted, though all precautions will be taken to avoid this. Risks
            associated with standard care procedures such as CT and MRI scans,
            will be discussed by your physician.
          </p>
          <p>
            As the two drugs are chemically similar, Alteplase and Tenecteplase
            have similar side effects.
            <br />
            The major risks are:
          </p>
          <p>
            Less likely (5 – 20%):
            <ul>
              <li>
                Bleeding (into the brain) risk is about 5%, as per the Safe
                Implementation of Thrombolysis in Stroke (SITS) registry; this
                is the major side effect.
              </li>
            </ul>
          </p>
          <p>
            Rarely (1 – 4%):
            <ul>
              <li>
                Bruising or bleeding from your injection site, nose or gums.
                Generally, such bleeding is easily controlled.
              </li>
            </ul>
          </p>
          <p>
            Very Rarely (&#60; 1%):
            <ul>
              <li>
                Alteplase or Tenecteplase can cause a serious allergic reaction
                (about 1 in 10,000 treatments). This can lead to low blood
                pressure, airway swelling and obstruction. This could
                potentially be fatal, but there have been no deaths reported due
                to allergy with either drug. This reaction can be treated with
                medication.
              </li>
              <li>
                Bleeding from the stomach or urinary tract. This is very rare
                (less than 1 chance in 100), but may require specific treatment
                (such as surgery) or a blood transfusion.
              </li>
            </ul>
          </p>
          <br />

          <p>
            It is possible that other drugs (prescription and non-prescription
            drugs), vitamins, or herbals can interact with the study
            intervention. This can result in either the intervention not working
            as expected or result in severe side effect.
          </p>
          <p>
            You will receive any new information during the course of the study
            concerning significant treatment findings that may affect your
            willingness to continue your participation.
          </p>
          <br />

          <p>
            <u>WHAT ARE THE REPRODUCTIVE RISKS?</u>
          </p>
          <p>
            The effects that tPA and TNK may have on an unborn baby (fetus) are
            unknown. If you are pregnant, you will only be allowed to
            participate in this study at the discretion of an expert stroke
            physician.
          </p>
          <br />

          <p>
            <u>WHAT ARE THE BENEFITS OF PARTICIPATING IN THIS STUDY?</u>
          </p>
          <p>
            If you agree to participate in this study, there may or may not be a
            direct medical benefit to you. Your stroke may be improved during
            the study, but there is no guarantee of that.
          </p>
          <p>
            We hope the information learned from this study will provide
            information about the study treatment(s) and stroke that may benefit
            others by helping to provide better future treatments for patients
            with stroke
          </p>
          <br />

          <p>
            <u>HOW WILL PARTICIPANT INFORMATION BE KEPT CONFIDENTIAL?</u>
          </p>
          <p>
            If you decide to participate in this study, the study doctors and
            study staff will only collect the information they need for this
            study.
          </p>
          <p>
            Records identifying you at this centre will be kept confidential
            and, to the extent permitted by the applicable laws, will not be
            disclosed or made publicly available, except as described in this
            consent document. Sometimes, by law, we may have to release your
            information with your name so we cannot guarantee absolute privacy.
            However, we will make every legal effort to make sure that your
            health information is kept private.
          </p>
          <p>
            Authorized representatives of the following organizations may look
            at your original (identifiable) medical/clinical study records at
            the site where these records are held, to check that the information
            collected for the study is correct and follows proper laws and
            guidelines.
          </p>
          <p>
            <li>The University of Calgary, the Sponsor of this study</li>
            <li>
              The Sunnybrook Research Ethics Board, who oversees the ethical
              conduct of this study in Ontario
            </li>
            <li>
              Toronto Western Hospital, to oversee the conduct of research at
              this location
            </li>
            <li>
              Health Canada (because they oversee the use of drugs in Canada)
            </li>
          </p>
          <p>
            Information that is collected about you for the study (called study
            data) may also be sent to the organizations listed above.
            Representatives of Clinical Trials Ontario, a not-for-profit
            organization, may see study data that is sent to the research ethics
            board for this study. No data relating to this study that includes
            your name will be released to anyone outside of the research team,
            nor will it be published by the researchers. Your name, telephone
            number and/or email will be provided to the AcT Coordinating Centre
            located at the University of Calgary, to contact you for conducting
            the telephone assessment required as part of this study. Every
            effort will be made to ensure that all parties who receive your
            private information understand the need to keep this information
            confidential.
          </p>
          <p>
            During research studies, it is important that the data we get is
            accurate and ensure the study is carried out correctly. Authorized
            representatives from the University of Calgary and the Sunnybrook
            Research Ethics Board, Health Canada and / or other regulatory
            agencies may look at your identifiable medical/clinical study
            records, including this consent form, in confidence and only for
            purposes of quality assurance.
          </p>
          <p>
            This study requires the transfer of identifiable information to the
            AcT Coordinating Centre located at the University of Calgary.
          </p>
          <p>
            The following information will be transferred to the University of
            Calgary:
            <ul>
              <li>First and last name</li>
              <li>Address</li>
              <li>Date of treatment</li>
              <li>Telephone number</li>
              <li>Email address</li>
              <li>Weight</li>
              <li>Family Physician</li>
            </ul>
          </p>
          <p>
            If the results of this study are published, your identity will
            remain confidential. It is expected that the information collected
            during this study will be used in analyses and will be published/
            presented to the scientific community at meetings and in journals.
            This information may also be used as part of a submission to
            regulatory authorities around the world to support the approval of
            the study intervention.
          </p>
          <p>
            By signing the consent form, you are giving permission for the study
            doctor/staff to collect, use and disclose information about you from
            a number of sources. Any health information that we get from any of
            these records will be limited to only what is needed for the study.
            These possible sources include your personal hospital electronic
            medical records, the OPTIMISE registry, your hospital site, other
            health care providers that you may have seen in the past (i.e. your
            family doctor) or the Canadian Institute for Health Information
            (CIHI) databases. CIHI collects data from hospitals in Canada
            including information about how often Canadians go to the hospital,
            how long they stayed, what types of doctors they saw, and other
            information about these hospitalizations/emergency department (ED)
            visits. This information is stored in the CIHI clinical
            administrative databases, along with your health care number. Your
            name is not included in these databases. Even though the likelihood
            that someone may identify you from the study data is very small, it
            can never be completely eliminated.
          </p>
          <p>
            In order to locate information about your past and future
            hospitalizations or ED visits up until a year after enrolment, which
            may include hospitals other than where you were originally admitted
            at the time of your stroke, authorized personnel from the study
            hospitals or registries will provide your health care number
            directly to CIHI solely for the purpose of extracting your
            hospitalization records from its databases. CIHI will then provide
            these records back to the study investigators without the health
            care number, using an anonymized study identification number. The
            study investigators will add the CIHI data to the study data based
            on this study identification number.
          </p>
          <p>
            The original copy of the signed consent form will be kept on-site at
            the hospital for at least 5 years.
          </p>
          <p>
            Research Information in Shared Clinical Records
            <br />
            If you participate in this study, information about you from this
            research project may be stored in your hospital file and in the
            University Health Network (UHN) computer system. The UHN shares the
            patient information stored on its computers with other hospitals and
            health care providers in Ontario so they can access the information
            if it is needed for your clinical care. The study team can tell you
            what information about you will be stored electronically and may be
            shared outside of the UHN. If you have any concerns about this, or
            have any questions, please contact the UHN Privacy Office at
            416-340-4800, x6937 (or by email at privacy@uhn.ca).
          </p>
          <p>
            A redacted copy will also be encrypted and electronically stored at
            the AcT Coordinating Centre located at the University of Calgary for
            review.
          </p>
          <p>
            After the study is done, we will still need to securely store your
            health data that was collected as part of the study. In Canada, the
            law says we have to keep the data stored for 25 years after the end
            of the study; after which the all the study data will be destroyed.
          </p>
          <p>
            If you have any questions about your rights as a research
            participant, any ethical issues related to this study, or about the
            confidentiality of your data, you may call The Chair of the
            Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144
          </p>
          <br />

          <p>
            <u>
              WILL FAMILY DOCTORS/HEALTH CARE PROVIDERS KNOW WHO IS
              PARTICIPATING IN THIS STUDY?
            </u>
          </p>
          <p>
            Your family doctor/health care provider will be informed that you
            had a stroke and were treated with a clot-busting medication so that
            you can be provided with appropriate medical care.
          </p>
          <br />

          <p>
            <u>WILL INFORMATION ABOUT THIS STUDY BE AVAILABLE ONLINE?</u>
          </p>
          <p>
            A description of this clinical trial is available on
            <a
              href="http://www.ClinicalTrials.gov"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://www.ClinicalTrials.gov
            </a>
            , as encouraged by Health Canada. This Web site will not include any
            information that can identify you. At most, the Web site will
            include a summary of the results. You can search this Web site at
            any time.
          </p>
          <br />

          <p>
            <u>WHAT IS THE COST TO PARTICIPANTS?</u>
          </p>
          <p>
            The clot-busting medication (TNK or tPA) has been supplied to you at
            no charge. The costs of your medical treatment will be paid for by
            your provincial medical plan to the extent that such coverage is
            available. Participation in this study will not involve any
            additional costs to you or your private health care insurance.
          </p>
          <br />

          <p>
            <u>ARE STUDY PARTICIPANTS PAID TO BE IN THIS STUDY?</u>
          </p>
          <p>You will not be paid for taking part in this study.</p>
          <p>
            If you are harmed as a direct result of taking part in this study,
            all necessary medical treatment will be made available to you at no
            cost.
          </p>
          <p>
            In the event that you suffer injury as a result of participating in
            this research, no compensation will be provided for you by the
            University of Calgary, the hospital you received stroke treatment
            from, or the researchers. You still have all your legal rights.
            Nothing said here about treatment or compensation in any way alters
            your right to recover damages.
          </p>
          <br />

          <p>
            <u>WHAT ARE THE RIGHTS OF PARTICIPANTS IN A RESEARCH STUDY?</u>
          </p>
          <p>
            You will be told, in a timely manner, about new information that may
            be relevant to your willingness to stay in this study.
          </p>
          <p>
            You have the right to be informed of the results of this study once
            the entire study is complete. The results of this study will be
            available on the clinical trial registry (see the “Will information
            about this study be available online” section for more details).
          </p>
          <p>
            Your rights to privacy are legally protected by federal and
            provincial laws that require safeguards to ensure that your privacy
            is respected.
          </p>
          <p>
            By signing this form you do not give up any of your legal rights
            against the study doctor, sponsor or involved institutions for
            compensation, nor does this form relieve the study doctor, sponsor
            or their agents of their legal and professional responsibilities.
          </p>
          <p>
            You will be given a copy of this signed and dated consent form prior
            to participating in this study.
          </p>
          <br />

          <p>
            <u>WHOM DO PARTICIPANTS CONTACT FOR QUESTIONS?</u>
          </p>
          <p>
            If you have questions about taking part in this study, or if you
            suffer a research-related injury, you can talk to your study doctor,
            or the doctor who is in charge of the study at this institution.
            That person is:
          </p>
          <table style={{ width: "70%", textAlign: "left" }}>
            <tbody>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Dr. Aleksandra Pikula
                </td>
                <td style={{ width: "70%" }} valign="top">
                  416-464-0929
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Name
                </td>
                <td style={{ width: "70%" }} valign="top">
                  Telephone
                </td>
              </tr>
            </tbody>
          </table>

          <br />

          <p>
            If you have questions about your rights as a participant or about
            ethical issues related to this study, you can talk to someone who is
            not involved in the study at all. That person is:
          </p>
          <br />

          <p align="center">
            The Chair of the Sunnybrook Research Ethics Board at (416) 480-6100
            ext. 88144
          </p>

          <br />
          <br />
          <br />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeUhn/Texts/PatientElectronicText.js